import React from 'react';
import { GlobalContext } from '../../store/GlobalContext';

const useAlerta = () => {
  const { setMsgAlerta, timeoutRef } = React.useContext(GlobalContext);

  const fechaAlerta = React.useCallback(() => {
    setMsgAlerta(null);
    clearTimeout(timeoutRef.current);
  }, [setMsgAlerta, timeoutRef]);

  const abreAlerta = React.useCallback(
    (mensagem, tempo) => {
      fechaAlerta();
      setMsgAlerta(mensagem);
      timeoutRef.current = setTimeout(() => fechaAlerta(), tempo * 1000);
    },
    [fechaAlerta, setMsgAlerta, timeoutRef],
  );

  return { abreAlerta, fechaAlerta };
};

export default useAlerta;
